export const NULL_ERROR = 'Null response';
export const SIGNOUT_ERROR = 'Error on signout.';
export const UNAUTHORIZED_ERROR = 'Unauthorized.';
export const ACCESS_DENIED_ERROR = 'Access Denied.';
export const INTERNAL_SERVER_ERROR = 'Internal Server Error.';
export const IMPLEMENTATION_NOT_FOUND = 'implementations not found';
export const UNDER_REVIEW = 'Under Review';
export const VALIDATION_ERROR = 'Validation error';
export const ERRORS = {
  type: {
    NETWORK_DETAILS: 'NETWORK_DETAILS',
  },
} as const;
export const TOTP_ERRORS = {
  NotAuthorizedException: 'NotAuthorizedException',
  EnableSoftwareTokenMFAException: 'EnableSoftwareTokenMFAException',
} as const;
export const TEST_DATA_ERROR = `TEST DATA NOT FOUND`;
export const NO_TEST_DATA_DEFINED = `No test data defined`;
